import { IFile } from '../../_entities';

export class FileBase {
	isPdf = (file: IFile) => file.ext.toLowerCase().endsWith(".pdf");

	isImage = (file: IFile) => FileBase.imageExtensions.indexOf(file.ext.toLowerCase()) !== -1;

	static imageExtensions = [".png", ".jpg", ".jpeg", ".bmp", ".gif"];

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/file/file-base.ts